<header class="app-header">
    <div class="header-breadcrumb">
        <span class="crumb-home">Overview</span>
        <span class="crumb-sep">/</span>
        <span class="crumb-current">{{ currentPage() }}</span>
    </div>
    <div class="header-actions">
        <div class="top-user">
            <div class="user-avatar uppercase">{{ userInfo()?.userName?.slice(0, 2) ?? '?' }}</div>
            <div class="top-user-copy">
                <strong>{{ userInfo()?.name || userInfo()?.userName || 'User' }}</strong>
                <span>{{ userInfo()?.roles?.[0]?.explation || 'Administrator' }}</span>
            </div>
        </div>
    </div>
</header>
